import { apiBasic, apiGet, apiToken } from "./requests";
import { encodeToken } from "./utils";

/*export const getProducts = (data = null) => {
  let path = "products";
  return apiGet(path);
};*/

export const getClients = (params = null) => {
  let path = "filter-customers";
  return apiGet(path, params);
};

export const getClient = (corporationId = null) => {
  let path = "owner/" + corporationId;
  return apiGet(path);
};

export const newUser = (data) => {
  let path = "new-user";
  return apiToken(data, path);
};

export const editOwner = (data, queryId = null) => {
  let path = "edit-owner/" + queryId;
  return apiToken(data, path, "patch");
};

export const platforms = (data, platformId = null) => {
  let path = "platforms/" + platformId;
  return apiBasic({ token: encodeToken(data) }, path, "patch");
};

// Domains
// POST /superadmin/domains/:corporationId
export const createDomain = (corporationId, data) => {
  const path = `domains/${corporationId}`;
  return apiBasic(data, path);
};

// GET /superadmin/domains/cloudflare/hostname/:domainId
export const getDomainCloudflareHostname = (domainId) => {
  const path = `domains/cloudflare/hostname/${domainId}`;
  return apiGet(path);
};

// ✅ Obtener dominios de una corporación
export const getCorporationDomains = async (corporationId) => {
  const path = `domains/${corporationId}`;
  return apiGet(path);
};

// ✅ Eliminar dominio y Cloudflare custom hostname
export const deleteDomainCloudflareHostname = async (domainId) => {
  const path = `domains/cloudflare/hostname/${domainId}`;
  return apiBasic({}, path, "delete");
};

// This endpoint returns the standard JSON envelope, not an encoded token.
export const saveClientDetails = (corporationId, data) => apiBasic(data, `client-details/${corporationId}`, "patch");
